import { render, staticRenderFns } from "./mian-detail.vue?vue&type=template&id=296c73f8&scoped=true"
import script from "./mian-detail.vue?vue&type=script&lang=js"
export * from "./mian-detail.vue?vue&type=script&lang=js"
import style0 from "./mian-detail.vue?vue&type=style&index=0&id=296c73f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296c73f8",
  null
  
)

export default component.exports